module.exports = __webpack_public_path__ + "static/media/Ibnul-Qayyim-Bin-Mustofa.7d322d73.jpeg";